import {useQuery} from "react-query";
import axios from "axios";
import {useSnackbar} from "notistack";
import {PerformanceTotalizer} from "../PerformanceTotalizer.types";

const API_URL = "api/power-station/performance-analysis/totalizers";

const fetchPerformanceTotalizers = async (
    powerStationIds: number[],
    startDateTime: string,
    endDateTime: string
): Promise<PerformanceTotalizer[]> => {
    try {
        const response = await axios.post<{ data: PerformanceTotalizer[] }>(
            API_URL,
            {powerStationIds},
            {
                params: {startDateTime, endDateTime},
                timeout: 30000,
            }
        );

        return response.data.data;
    } catch (error) {
        console.error("Erro ao buscar totalizadores de performance:", error);
        return Promise.reject(error);
    }
};

export const usePerformanceTotalizersQuery = (
    powerStationIds: number[],
    startDateTime: string | null,
    endDateTime: string | null
) => {
    const {enqueueSnackbar} = useSnackbar();

    return useQuery({
        queryKey: ["performance-totalizers", powerStationIds, startDateTime, endDateTime],
        queryFn: () => fetchPerformanceTotalizers(powerStationIds, startDateTime as string, endDateTime as string),
        enabled: !!startDateTime && !!endDateTime && powerStationIds.length > 0,
        keepPreviousData: true,
        onError: (error: any) => {
            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.detail ||
                error?.message ||
                "Erro ao carregar totalizadores de performance";
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 3000,
            });
        },
    });
};
